// @flow
import React from "react";
import type {Product} from "../../../models/Product";
import "./NscProductView.scss";

export type NscProductViewProps = {
	product: Product,
	close: () => void,
}

const NscProductView = (props: NscProductViewProps) => {
	return <div className="selectedProduct">
		<img src={props.product.galleryImage.attachmentUrl} alt={props.product.galleryImage.caption || props.product.name}/>
		<span className={"hpm-productDescription"}>
			<span>{props.product.name}</span>
			<div
				className={"hpm-close-dealerList"}
				onClick={() => props.close()}
				onKeyDown={e => e.key === "Enter" && props.close()}
				role="button"
				tabIndex={0}
				aria-label="Close"
			/>
		</span>
	</div>;
};

export default NscProductView;
